module.exports = __webpack_public_path__ + "static/Eric-e53d9ff5940b178c70e6276b9d996e53.jpg";